module.exports = __webpack_public_path__ + "img/quick_buy.8ff479bb.svg";